export const GROWTHBOOK_CONFIG = {
  GROWTHBOOK_CONFIG: {
    baseUrlKey: 'growthbookURL',
    growthbookSdkKey: 'growthbookSdkKey',
    endPoint: `api/features`,
    method: 'GET',
  },
}
